import React, { useEffect, useMemo } from "react";

export default function Review() {
  const ua = navigator.userAgent || "";
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isAndroid = /Android/i.test(ua);

  const IOS_WRITE_REVIEW = "https://apps.apple.com/app/id6748700654?action=write-review";
  const PLAY_STORE = "https://play.google.com/store/apps/details?id=com.satstacker.app";

  const target = useMemo(() => {
    if (isIOS) return IOS_WRITE_REVIEW;
    if (isAndroid) return PLAY_STORE;
    return null;
  }, [isIOS, isAndroid]);

  useEffect(() => {
    // 1-tap flow on mobile
    if (target) {
      const t = setTimeout(() => {
        window.location.href = target;
      }, 250);
      return () => clearTimeout(t);
    }
  }, [target]);

  return (
    <div className="min-h-screen bg-zinc-950 text-white flex items-center justify-center px-6">
      <div className="max-w-xl w-full text-center">
        <h1 className="text-4xl font-bold mb-4">Leave a quick review</h1>
        <p className="text-lg text-zinc-300 mb-6">
          Reviews help SatStacker reach more Bitcoiners.
        </p>

        <div className="flex flex-col gap-4">
          <a
            href={IOS_WRITE_REVIEW}
            target="_blank"
            rel="noreferrer"
            className="block w-full py-3 rounded-xl bg-brand hover:opacity-90 text-black text-lg font-semibold"
          >
            Review on iOS
          </a>

          <a
            href={PLAY_STORE}
            target="_blank"
            rel="noreferrer"
            className="block w-full py-3 rounded-xl border border-zinc-700 text-white text-lg font-semibold"
          >
            Review on Google Play
          </a>
        </div>

        <p className="mt-8 text-sm text-zinc-500">
          If you’re on mobile, you should be redirected automatically.
        </p>
      </div>
    </div>
  );
}